import React from 'react'
import { Text } from '@workwhile/ui'
import { formatCurrency } from 'lib/currency'

export const AmountRender = ({
  value,
  props,
}: {
  value: number | undefined
  props?: any
}) => {
  if (value === undefined) {
    return <Text inline>-</Text>
  }

  let color = 'neutral'
  if (value < 0) {
    color = 'error'
  } else if (value > 0) {
    color = 'success'
  }

  return (
    <Text color={color} fontWeight="bold" inline {...props}>
      {value < 0 ? '-' : ''}
      {formatCurrency(Math.abs(value))}
    </Text>
  )
}
